import React, { useEffect, useMemo } from 'react';
import { notification } from 'antd';
import { useDispatch } from 'react-redux';
import { GeneralActions } from '../../store/actions';

const Context = React.createContext({ name: 'Default' });

const PushNotifications = ({ notificationData }) => {

    const [api, contextHolder] = notification.useNotification({
        stack: {
            threshold: 2
        }
    });
    const dispatch = useDispatch();

    const key = `open${Date.now()}`;

    const openNotification = () => {
        api.info({
            message: `${notificationData?.data?.title || 'A new Notification!'}`,
            description: <Context.Consumer>{() => notificationData?.data?.body || 'Custom Notification'}</Context.Consumer>,
            placement: 'topRight',
            key,
            // onClick: () => alert('notification Clicked!!')
        });
    };

    useEffect(() => {
        openNotification()
        setTimeout(() => {
            dispatch(GeneralActions.ClearNotifications())
        }, 3000)
    }, [])

    const contextValue = useMemo(() => ({ name: 'Ant Design' }), []);

    return (
        <Context.Provider value={contextValue}>
            {contextHolder}
        </Context.Provider>
    );
};
export default PushNotifications;